var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _g2, _path13, _g3, _path14, _g4, _path15, _g5, _path16, _g6, _path17, _g7, _path18, _g8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEswlogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 28,
    viewBox: "0 0 101 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.0544 12.6963L48.2455 26.725H45.2872L42.957 18.5197L40.6112 26.725H37.6517L32.8433 12.6963H36.6618L39.227 21.5356L41.5045 12.6963H44.3934L46.6709 21.5356L49.2371 12.6963H53.0544Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0623 19.9554C64.0623 18.9084 63.7155 18.0319 63.0246 17.3262C62.3347 16.6205 61.4593 16.2673 60.403 16.2673C59.325 16.2673 58.4451 16.616 57.7597 17.313C57.0747 18.0097 56.7315 18.8905 56.7315 19.9554C56.7315 21.0024 57.0775 21.8727 57.7683 22.5662C58.459 23.261 59.3393 23.608 60.403 23.608C61.465 23.608 62.3405 23.2584 63.0275 22.5619C63.7155 21.8656 64.0623 20.9958 64.0623 19.9554ZM67.7179 19.9554C67.7179 21.9612 67.0167 23.6426 65.6135 25.0006C64.2104 26.3601 62.4745 27.039 60.403 27.039C58.3296 27.039 56.5909 26.3601 55.1879 25.0006C53.7847 23.6426 53.0835 21.9612 53.0835 19.9554C53.0835 17.9553 53.7875 16.2691 55.1963 14.896C56.6051 13.5223 58.34 12.8359 60.403 12.8359C62.4745 12.8359 64.2104 13.5209 65.6135 14.8907C67.0167 16.2616 67.7179 17.9497 67.7179 19.9554Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6726 17.891C75.6726 17.2203 75.5048 16.7396 75.1719 16.4484C74.8365 16.1566 74.2702 16.0121 73.4698 16.0121H72.7707V19.6292H73.4091C74.1851 19.6292 74.7568 19.4878 75.1223 19.2051C75.4916 18.9229 75.6726 18.4848 75.6726 17.891ZM80.0031 26.7486H75.8656L72.7707 21.4548V26.7486H69.2549V13.127H73.3733C75.5658 13.127 77.1057 13.4727 77.9915 14.1633C78.8772 14.8548 79.3207 15.9467 79.3207 17.4405C79.3207 18.4875 79.0649 19.3422 78.5529 20.0035C78.0385 20.6653 77.2932 21.1027 76.3137 21.3135L80.0031 26.7486Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3022 26.7486H80.9902V13.127H84.6457V23.6245H88.3022V26.7486Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3548 19.9554C97.3548 18.6436 97.0193 17.6774 96.351 17.0573C95.6857 16.4367 94.645 16.1264 93.2346 16.1264H92.9288V23.7477H93.2346C94.6508 23.7477 95.6902 23.4416 96.3566 22.8272C97.0221 22.2126 97.3548 21.2552 97.3548 19.9554ZM101 19.9554C101 22.2484 100.339 23.955 99.0166 25.0716C97.6904 26.1894 95.6386 26.7486 92.8577 26.7486H89.4102V13.127H92.3318C95.4184 13.127 97.6323 13.6796 98.9802 14.7854C100.328 15.891 101 17.614 101 19.9554Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1387 7.61893C38.0299 6.68771 37.4633 6.22156 36.4403 6.22156C35.5061 6.22156 34.9269 6.68771 34.7001 7.61893H38.1387ZM39.6323 8.59223H34.6054C34.6412 9.18694 34.8158 9.65006 35.1279 9.98391C35.4415 10.317 35.8596 10.484 36.385 10.484C37.2642 10.484 37.9212 10.0684 38.3561 9.23649L39.5649 9.92194C38.8674 11.1831 37.8167 11.8137 36.4126 11.8137C35.4073 11.8137 34.6054 11.5027 34.007 10.881C33.41 10.2599 33.1104 9.43306 33.1104 8.4008C33.1104 7.40477 33.4183 6.58702 34.0345 5.94738C34.6505 5.30774 35.4429 4.98828 36.4126 4.98828C37.4276 4.98828 38.217 5.28004 38.7836 5.86463C39.3506 6.4494 39.6323 7.26714 39.6323 8.31805V8.59223Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4709 8.78425C46.4709 9.70748 46.1832 10.4425 45.6085 10.9903C45.0321 11.5392 44.2466 11.8134 43.2511 11.8134C41.5387 11.8134 40.5138 11.0731 40.1797 9.59295L41.4436 9.00303C41.6788 9.89891 42.3031 10.3469 43.3182 10.3469C43.7886 10.3469 44.1628 10.2141 44.4392 9.94846C44.7158 9.68422 44.8534 9.33208 44.8534 8.89347C44.8534 8.47314 44.6909 8.13574 44.3652 7.87949C44.2288 7.76975 43.8163 7.54565 43.1284 7.20825C42.1672 6.73305 41.5068 6.31254 41.1438 5.94691C40.6814 5.49 40.4505 4.91411 40.4505 4.21961C40.4505 3.42512 40.7191 2.77838 41.2524 2.28027C41.7876 1.78252 42.4943 1.5332 43.3735 1.5332C44.8587 1.5332 45.7915 2.07322 46.1723 3.15094L44.936 3.79519C44.5643 3.20102 44.0844 2.90428 43.4945 2.90428C43.0693 2.90428 42.7309 3.01634 42.4821 3.23973C42.2332 3.46383 42.1096 3.7627 42.1096 4.13792C42.1096 4.55825 42.2816 4.90524 42.6251 5.17942C42.807 5.31651 43.2511 5.54949 43.9564 5.87836C44.8629 6.29869 45.4969 6.70517 45.8587 7.09762C46.267 7.54565 46.4709 8.10786 46.4709 8.78425Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1207 11.5527H56.651L55.5788 6.71442C55.5788 6.70554 55.5205 6.25787 55.4025 5.37158C55.32 5.82866 55.1719 6.28095 54.9545 6.72827L52.4124 11.9503L49.87 6.61853C49.6638 6.18932 49.504 5.77379 49.3945 5.37158C49.3859 5.7919 49.3283 6.2442 49.2183 6.72827L48.173 11.5527H46.7183L49.0147 1.36914L51.8811 7.52347C51.9635 7.7062 52.1397 8.14961 52.4124 8.853C52.5119 8.56035 52.6983 8.11694 52.971 7.52347L55.768 1.36914L58.1207 11.5527Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1732 6.67303C67.1732 5.65923 66.8263 4.79354 66.1337 4.07595C65.4401 3.35888 64.604 3.00053 63.6246 3.00053C62.6364 3.00053 61.8005 3.35604 61.1133 4.06938C60.4227 4.78182 60.0787 5.65018 60.0787 6.67303C60.0787 7.68753 60.4227 8.5511 61.1133 9.26354C61.8005 9.97634 62.6364 10.3327 63.6246 10.3327C64.604 10.3327 65.4401 9.97438 66.1337 9.25697C66.8263 8.53973 67.1732 7.67848 67.1732 6.67303ZM68.8152 6.67303C68.8152 8.0988 68.3064 9.31166 67.2885 10.312C66.2677 11.3131 65.0464 11.8132 63.6246 11.8132C62.1857 11.8132 60.9588 11.3131 59.9493 10.312C58.9398 9.31166 58.4336 8.0988 58.4336 6.67303C58.4336 5.23891 58.9371 4.02356 59.9438 3.02752C60.9485 2.03149 62.1744 1.5332 63.6246 1.5332C65.0661 1.5332 66.2902 2.03433 67.3026 3.03409C68.3121 4.03439 68.8152 5.24796 68.8152 6.67303Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5581 11.5522H75.5194L71.6737 6.54949V11.5522H70.0981V1.75293H71.6737V5.80917L75.1641 1.75293H77.096L73.2502 6.11123L77.5581 11.5522Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1608_90145",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 101,
    height: 28
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 28H101V0H0V28Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1608_90145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.0229 11.5522H79.5985V1.75293H78.0229V11.5522Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1608_90145",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 101,
    height: 28
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 28H101V0H0V28Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1608_90145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.024 11.937L83.7328 5.83754C83.386 5.50813 83.0758 5.14321 82.7946 4.741V11.5527H81.3398V1.36914L87.5102 7.35885C87.8456 7.67885 88.1972 8.07591 88.5682 8.55147V1.75289H90.024V11.937Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1608_90145",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 101,
    height: 28
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 28H101V0H0V28Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1608_90145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.881 7.45437C100.881 8.84357 100.486 9.9172 99.698 10.6755C98.9089 11.4335 97.8086 11.8132 96.3978 11.8132C94.8213 11.8132 93.5616 11.3311 92.6176 10.3667C91.6776 9.40329 91.207 8.17196 91.207 6.67303C91.207 5.17498 91.6963 3.94347 92.6815 2.97976C93.6637 2.01533 94.901 1.5332 96.3978 1.5332C97.9107 1.5332 99.132 2.10483 100.065 3.2463L98.9089 4.12407C98.2677 3.36599 97.4373 2.98633 96.4221 2.98633C95.3714 2.98633 94.513 3.32426 93.8475 4.00083C93.182 4.67669 92.8493 5.56263 92.8493 6.65918C92.8493 7.7749 93.182 8.67451 93.8475 9.35943C94.513 10.0447 95.3771 10.3874 96.4362 10.3874C97.3436 10.3874 98.0531 10.1747 98.5705 9.75028C99.0878 9.32498 99.3466 8.74767 99.3466 8.01587V7.87932H97.0081V6.53594H100.854C100.871 7.06618 100.881 7.37215 100.881 7.45437Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1608_90145",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 101,
    height: 28
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 28H101V0H0V28Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1608_90145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5543 14.6825C21.5365 16.8017 20.7303 18.9161 19.1295 20.5294C17.5642 22.1091 15.4806 22.9789 13.2647 22.9789C11.0489 22.9789 8.96668 22.1091 7.39996 20.5294C4.1667 17.2678 4.1667 11.96 7.39996 8.69843C8.95171 7.13379 11.0091 6.26579 13.2015 6.24981L17.4939 1.91921C16.1489 1.46496 14.7255 1.22754 13.2647 1.22754C9.7202 1.22754 6.38764 2.62082 3.88167 5.14918C-1.29366 10.368 -1.29366 18.8602 3.88026 24.0794C6.38764 26.6068 9.7202 27.9996 13.2647 27.9996C16.8105 27.9996 20.1432 26.6068 22.649 24.0794C26.3229 20.3738 27.3872 15.0177 25.8439 10.3547L21.5543 14.6825Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1608_90145",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 101,
    height: 28
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 28H101V0H0V28Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1608_90145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6499 10.6938L17.1531 14.2267L27.7546 3.53363L24.2514 0L13.6499 10.6938Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1608_90145",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 101,
    height: 28
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 28H101V0H0V28Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1608_90145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5764 14.8083L13.0719 11.2754L12.4888 11.8639L15.9921 15.3973L16.5764 14.8083Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1608_90145",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 101,
    height: 28
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 28H101V0H0V28Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1608_90145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.409 15.9857L11.9058 12.4531L11.3228 13.0404L14.8259 16.5738L15.409 15.9857Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1608_90145",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 101,
    height: 28
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 28H101V0H0V28Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1608_90145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1562 14.2172L13.6594 17.75L14.2428 17.1618L10.7397 13.6289L10.1562 14.2172Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEswlogo);
export default __webpack_public_path__ + "static/media/eswlogo.b87bd2d9130fe657ba8382c9443d395c.svg";
export { ForwardRef as ReactComponent };